import React, { Component } from "react";
import Header from "../../components/header/Header";
import { handleLandingScroll } from "../../utils/scroll";
import { trackPageview } from "../../utils/analytics";

function Repo({ id, name, desc, tech, stars, year }) {
  return (
    <div className="proj">
      <div className="num">{id}</div>
      <div>
        <div className="name">{name}</div>
        <div className="desc">{desc}</div>
      </div>
      <div className="tech">
        {tech.map((t) => <span key={t}>{t}</span>)}
      </div>
      <div className="stat"><span className="yr">★ {stars}</span><span className="done">{year}</span></div>
    </div>
  );
}

class Opensource extends Component {
  componentDidMount() {
    handleLandingScroll(this.props.location);
    trackPageview();
  }
  render() {
    return (
      <>
        <div className="grid-bg" />
        <Header theme={this.props.theme} />

        <div className="wrap">

          {/* HERO */}
          <section className="hero">
            <div className="label-strip">
              <span><b>GITHUB DOSSIER</b></span>
              <span>@WALIDMAANINOU</span>
              <span><b>ACTIVE</b> · MEMBER SINCE 2018</span>
            </div>

            <h1 className="huge">
              <span className="row">CODE</span>
              <span className="row indent">in the <span className="ital">open</span>.</span>
            </h1>

            <div className="sub-row">
              <p>
                The GitHub view — public repositories, upstream contributions,
                and the long tail of small fixes. The <b>truer document</b>:
                code is harder to fake than a CV.
              </p>
              <div className="meta-block">
                <div className="k">DOSSIER</div>
                <div className="row"><span className="lab">HANDLE</span><span>@WALIDMAANINOU</span></div>
                <div className="row"><span className="lab">REPOS (PUBLIC)</span><span>~23</span></div>
                <div className="row"><span className="lab">UPSTREAM PRs</span><span>40+</span></div>
                <div className="row"><span className="lab">MEMBER SINCE</span><span>2018</span></div>
                <div className="row"><span className="lab">PRIMARY LANG.</span><span>PYTHON</span></div>
              </div>
            </div>

            <div className="cta-row">
              <a className="primary" href="https://github.com/walidMaaninou" target="_blank" rel="noopener noreferrer">OPEN GITHUB <span className="arrow">↗</span></a>
              <a href="https://github.com/walidMaaninou?tab=repositories" target="_blank" rel="noopener noreferrer">ALL REPOS <span className="arrow">↗</span></a>
              <a href="mailto:maaninou.walid@gmail.com">QUESTIONS? <span className="arrow">→</span></a>
            </div>
          </section>

          {/* SELECTED REPOS */}
          <section className="section" id="repos">
            <div className="section-head">
              <h2 className="section-title">01 <em>·</em> SELECTED REPOS</h2>
              <div className="meta"><b>05</b><br/>OF MANY</div>
            </div>

            <div className="proj-list">
              <Repo
                id="01"
                name="scrape-stack"
                desc="Opinionated Python scaffold for production scrapers — async session, polite request budget, proxy rotation, dead-letter queue. Starting point for most client work."
                tech={["python", "scrapy", "redis"]}
                stars="184"
                year="2025"
              />
              <Repo
                id="02"
                name="price-pulse"
                desc="Reference implementation of a price-tracking pipeline: scrape → normalize → dedup → API. Companion to a write-up on anti-bot-resilient scrapers."
                tech={["python", "fastapi", "postgres"]}
                stars="92"
                year="2024"
              />
              <Repo
                id="03"
                name="dom-drift"
                desc="A small library that watches a target page and quantifies how much its DOM has shifted since the last successful scrape. Catches silent failures."
                tech={["python", "playwright"]}
                stars="47"
                year="2024"
              />
              <Repo
                id="04"
                name="masterPortfolio"
                desc="The fork that started this site. Heavily modified — the version you're reading now shares almost nothing with it."
                tech={["react", "css"]}
                stars="12"
                year="2024"
              />
              <Repo
                id="05"
                name="walidmaaninou.com"
                desc="This site. Brutalist rewrite, May ’26. Hand-built, no template."
                tech={["react", "css"]}
                stars="—"
                year="2026"
              />
            </div>
          </section>

          {/* UPSTREAM */}
          <section className="section">
            <div className="section-head">
              <h2 className="section-title">02 <em>·</em> UPSTREAM</h2>
              <div className="meta"><b>40+</b><br/>MERGED PRs</div>
            </div>

            <p style={{ fontSize: 17, lineHeight: 1.7, maxWidth: "62ch", marginBottom: 24 }}>
              Smaller, mostly bug fixes and docs. Across <b>Tensorflow</b>,{" "}
              <b>scikit-learn</b>, <b>Sympy</b>, <b>Kiwix</b>, <b>Keras</b>,{" "}
              <b>FOSSASIA</b>, and a long tail of one-PR repos. The
              unglamorous part open source actually needs.
            </p>

            <div className="role-list">
              <div className="role-block">
                <div className="when"><b>2019 →</b><span className="where">ONGOING</span></div>
                <div>
                  <h3>GITHUB <em>developer program</em></h3>
                  <div className="where-line">MEMBER · ACTIVE</div>
                  <p>Contributing to TensorFlow, scikit-learn, Sympy, Kiwix, Keras, FOSSASIA, plus many smaller projects.</p>
                </div>
                <div className="side"></div>
              </div>

              <div className="role-block">
                <div className="when"><b>2019 – 2020</b><span className="where">FACILITATOR</span></div>
                <div>
                  <h3>GOOGLE <em>explore ML</em></h3>
                  <div className="where-line">FACILITATOR · MICROSOFT STUDENT PARTNER · MOZILLA CAMPUS CAPTAIN</div>
                  <p>Workshops, hackathons, and intro-ML sessions for university students. Translating things I half-understood into things I had to explain.</p>
                </div>
                <div className="side"></div>
              </div>
            </div>
          </section>

          <p style={{ marginTop: 32, fontFamily: "'JetBrains Mono', monospace", fontSize: 12, textTransform: "uppercase", letterSpacing: ".06em", textAlign: "center", padding: "0 0 32px" }}>
            <a className="inline" href="https://github.com/walidMaaninou">→ FULL HISTORY ON GITHUB</a>
          </p>
        </div>

        {/* CONTACT SLAB */}
        <div className="wrap">
          <div className="foot-slab">
            <div className="inner">
              <h2>READ THE <em>code.</em><br/>STILL CURIOUS?</h2>
              <div>
                <p>Get in touch — I'll talk through any of the repos or contributions in detail.</p>
                <div className="links">
                  <a href="https://github.com/walidMaaninou">→ GITHUB <span>@WALIDMAANINOU</span></a>
                  <a href="mailto:maaninou.walid@gmail.com">→ EMAIL <span>MAANINOU.WALID@GMAIL.COM</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="site-footer">
          <span>© 2026 MAANINOU WALID · CASABLANCA · GMT+1</span>
          <span>
            <a href="mailto:maaninou.walid@gmail.com">EMAIL</a>
            <a href="https://github.com/walidMaaninou">GITHUB</a>
            <a href="https://www.linkedin.com/in/walid-maaninou-86a844102/">LINKEDIN</a>
          </span>
        </footer>
      </>
    );
  }
}

export default Opensource;
